<ul>
  <li *ngFor="let summary of questions; index as i"
      [class.answered]="summary.answered"
      [class.active]="summary.questionId === currentQuestionId">
    <a (click)="onQuestionSelect(i + 1)">{{i + 1}}</a>
  </li>
</ul>
